<template>
  <div class="table table--hero slicing-profiles">
    <b-table :fields="fields" :items="profilesList" primary-key="id">
      <template v-slot:cell(actions)="data">
        <b-button variant="-primary" size="-small" @click="handleRestore(data.item)">{{$t('profiles.actions.restore')}}</b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";

  import ApplicationMixin from "@/mixins/application";

  export default {
    name: 'slicing-profiles-deleted-table',
    mixins: [ApplicationMixin],
    data() {
      return {
        fields: [
          {key: 'name', class: 'name'},
          //{key: 'slicer_id', formatter: this.slicerNameById, class: 'id'},
          {key: 'printer_type', class: 'printer'},
          {key: 'deleted_by_email', class: 'deleted_by'},
          {key: 'actions', class: 'actions'}
        ]
      }
    },
    computed: {
      ...mapGetters(['getProfiles']),

      profilesList() {
        return this.getProfiles.filter(profile => {
          return profile.deleted_by !== null;
        });
      }
    },
    methods: {
      ...mapActions(['restoreProfile']),

      handleRestore(profile) {
        this.restoreProfile(profile.id).then(data => {
          if (!data.result) {
            this.toast(this.$t('profiles.failedToDeleteProfile') + ': ' + data.message);
          }
        });
      }
    }
  }
</script>
